import { useSignUpStore } from '../stores/sign-up';
import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app';
import { PATH_SIGN_UP_INVITATION_REQUIRED } from '../common/constants/paths';

export default defineNuxtRouteMiddleware(() => {
  const signUpStore = useSignUpStore();

  if (!signUpStore.$state.isSignUpAvailable) {
    return navigateTo({ path: PATH_SIGN_UP_INVITATION_REQUIRED });
  }
});
